import Vue from 'vue';

import HCPayHome from '@/views/home.vue';
import HCPayMobile from '@/views/mobile.vue';
import HCPayPINCode from '@/views/pin-code.vue';
import HCPayHelpScreen from '@/views/help_screen.vue';
import HCPayFeedback from '@/views/feedback.vue';
import HCPayWelcome from '@/views/welcome.vue';
import HCPayVerifyIdentity from '@/views/verify_identity.vue';
import HCPayPaymentInProgress from '@/views/payment_in_progress.vue';
import HCPayTransactionComplete from '@/views/transaction_complete.vue';
import HCPayNotAvailable from '@/views/not_available.vue';
import HCPayGenericError from '@/views/generic_error.vue';
import HCPayLeadsGen from '@/views/leads_gen.vue';

// OPG 2.0 Components
import OPGHome from '@/views/2.0/home.vue';
import OPGMobile from '@/views/2.0/mobile.vue';
import OPGPINCode from '@/views/2.0/pin-code.vue';
import OPGConfirmPayment from '@/views/2.0/confirm-payment.vue';
import OPGVerifyIdentity from '@/views/2.0/verify_identity.vue';
import OPGPaymentInProgress from '@/views/2.0/payment_in_progress.vue';
import OPGTransactionComplete from '@/views/2.0/transaction_complete.vue';
import OPGNewTransactionComplete from '@/views/2.0/transaction_complete_two.vue';
import OPGConfirmPaymentQwarta from '@/views/2.0/confirm-payment-two.vue';
import OPGGenericErrorOpg2 from '@/views/generic_error_opg2.vue';
import OPGCancelPage from '@/views/2.0/cancel.vue';
import OPGAccountBlock from '@/views/2.0/account-block.vue';
import OPGSocialCommereceChatt from '@/views/2.0/social-commerce-chat.vue';

// LAZADA Components
import LAZHome from '@/views/lazada/home.vue';
import LAZMobile from '@/views/lazada/mobile.vue';
import LAZDenomination from '@/views/lazada/denomination.vue';
import LAZVerification from '@/views/lazada/verify_identity.vue';
import LAZPaymentInProgress from '@/views/lazada/payment-in-progress.vue';
import LAZTransactionComplete from '@/views/lazada/transaction_complete.vue';
import LAZNoHCPayApp from '@/views/lazada/no-hcpay-app.vue';
import LAZNoAccountHCPayApp from '@/views/lazada/install-hcpay-app.vue';
import LAZNoAccountAndApp from '@/views/lazada/no-account-app.vue';
import LAZUserCanceled from '@/views/lazada/user-cancel.vue';
import LAZTechnicalIssue from '@/views/lazada/tech-issue.vue';
import LAZPinLogin from '@/views/lazada/pin-code.vue';
import LAZConfirmPayment from '@/views/lazada/confirm-payment.vue';
import LAZAccountBlock from '@/views/lazada/account-block.vue';

import EligibilityQualification from '@/views/eligibility-qualification.vue';

Vue.component('home', HCPayHome);
Vue.component('mobile', HCPayMobile);
Vue.component('login-pin', HCPayPINCode);
Vue.component('help-screen', HCPayHelpScreen);
Vue.component('feedback', HCPayFeedback);
Vue.component('welcome', HCPayWelcome);
Vue.component('verify-identity', HCPayVerifyIdentity);
Vue.component('payment-in-progress', HCPayPaymentInProgress);
Vue.component('transaction-complete', HCPayTransactionComplete);
Vue.component('not-available', HCPayNotAvailable);
Vue.component('generic-error', HCPayGenericError);
Vue.component('leads-gen', HCPayLeadsGen);

/** OPG 2.0 */
Vue.component('opg-home', OPGHome);
Vue.component('mobile-login', OPGMobile);
Vue.component('pin-login', OPGPINCode);
Vue.component('confirm-payment', OPGConfirmPayment);
Vue.component('opg-verify-identity', OPGVerifyIdentity);
Vue.component('opg-payment-in-progress', OPGPaymentInProgress);
Vue.component('opg-transaction-complete', OPGTransactionComplete);
Vue.component('opg-new-transaction-complete', OPGNewTransactionComplete);
Vue.component('confirm-payment-qwarta', OPGConfirmPaymentQwarta);
Vue.component('generic-error-opg2', OPGGenericErrorOpg2);
Vue.component('cancel-page', OPGCancelPage);
Vue.component('account-block', OPGAccountBlock);
Vue.component('social-commerce-chat', OPGSocialCommereceChatt);

/** Lazada Components */
Vue.component('lazada-home', LAZHome);
Vue.component('lazada-mobile', LAZMobile);
Vue.component('lazada-denomination', LAZDenomination);
Vue.component('lazada-verification', LAZVerification);
Vue.component('lazada-payment-in-progress', LAZPaymentInProgress);
Vue.component('lazada-transaction-complete', LAZTransactionComplete);
Vue.component('lazada-no-hcpay-app', LAZNoHCPayApp);
Vue.component('lazada-no-account-hcpay-app', LAZNoAccountHCPayApp);
Vue.component('lazada-no-account-and-app', LAZNoAccountAndApp);
Vue.component('lazada-user-canceled', LAZUserCanceled);
Vue.component('lazada-technical-issue', LAZTechnicalIssue);
Vue.component('lazada-pin-login', LAZPinLogin);
Vue.component('lazada-confirm-payment', LAZConfirmPayment);
Vue.component('lazada-account-block', LAZAccountBlock);

Vue.component('lazada-eligibility-qualification', EligibilityQualification);
